<template>
    <div>
        <p class="title is-3 is-spaced">Payment system settings</p>

        <!-- Logins -->
        <p class="title is-4 is-spaced">Payment system logins</p>
        <section class="accordions">
            <article class="accordion"
                     :class="{'is-active': newLoginVisible}">
                <div class="accordion-header toggle is-size-5"
                     @click="newLoginVisible = !newLoginVisible">
                    <a>New login ⯆</a>
                </div>
                <div class="accordion-body">
                    <div class="accordion-content has-background-dark has-text-white">
                        <div class="field">
                            <label class="label">Address</label>
                            <div class="control">
                                <input class="input oc-input"
                                       type="text"
                                       v-model="newLogin.address">
                            </div>
                        </div>
                        <div class="field">
                            <label class="label">Login</label>
                            <div class="control">
                                <input class="input oc-input"
                                       type="text"
                                       v-model="newLogin.login">
                            </div>
                        </div>
                        <div class="field">
                            <label class="label">Password</label>
                            <div class="control">
                                <input class="input oc-input"
                                       type="text"
                                       v-model="newLogin.password">
                            </div>
                        </div>

                        <div class="field">
                            <div class="control">
                                <button class="button is-success"
                                        @click="createLogin()"
                                        :disabled="!newLogin.address || !newLogin.login || !newLogin.password">Create login</button>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </section>

        <table class="table">
            <tr>
                <th>Address</th>
                <th>Login</th>
                <th>Password</th>
            </tr>
            <tr v-for="psLogin in settings.paymentSystemSettings.logins" :key="psLogin.login">
                <th>{{psLogin.address}}</th>
                <td>{{psLogin.login}}</td>
                <td>{{psLogin.password}}</td>
            </tr>
        </table>
    </div>
</template>
<script>
import systemSettingsService from "../../services/systemsettings.service";

export default {
    name: "system-settings",
    data() {
        return {
            settings: {
                paymentSystemSettings: {
                    logins: null
                }
            },
            newLoginVisible: false,
            newLogin: {
                address: null,
                login: null,
                password: null
            }
        };
    },
    async mounted() {
        this.settings = await systemSettingsService.get();
    },
    methods: {
        async createLogin() {
            this.settings.paymentSystemSettings.logins.push(this.newLogin);
            this.settings = await systemSettingsService.save(this.settings);
            this.newLogin.address = "";
            this.newLogin.login = "";
            this.newLogin.password = "";
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/system/payment-system.vue